import rangy from '@yola/rangy';
import view from '../../view';

const getAdvancedSelection = () => {
  const liveDocument = view.accessors.getLiveDocument();
  return rangy.getSelection(liveDocument.defaultView);
};

export default getAdvancedSelection;
